/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Ende der Ergebnisse`
};

const en_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `End of results`
};

const es_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Fin de los resultados`
};

const fr_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Fin des résultats`
};

const it_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Fine dei risultati`
};

const nl_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Einde van de resultaten`
};

const pt_pagination__end_of_results = /** @type {(inputs: {}) => string} */ () => {
	return `Fim dos resultados`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pagination__end_of_results(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pagination__end_of_results", locale)
	if (locale === "de") return de_pagination__end_of_results(inputs)
	if (locale === "en") return en_pagination__end_of_results(inputs)
	if (locale === "es") return es_pagination__end_of_results(inputs)
	if (locale === "fr") return fr_pagination__end_of_results(inputs)
	if (locale === "it") return it_pagination__end_of_results(inputs)
	if (locale === "nl") return nl_pagination__end_of_results(inputs)
	return pt_pagination__end_of_results(inputs)
};